import React from 'react';
import { calculatePathDistance } from '../utils/pathCalculations';
import '../../../styles/modes/customMode.css';

const PathDistance = ({ customPath }) => {
  if (customPath.length <= 1) return null;
  
  return (
    <div className="path-distance">
      Path Distance: {calculatePathDistance(customPath)} km
    </div>
  );
};

export default PathDistance; 